<mat-icon svgIcon="alert_circle"></mat-icon>
<div class="news-list">
    <ng-container #container></ng-container>
</div>
